import SectionHeading from '../components/SectionHeading';
import GalleryGrid from '../components/GalleryGrid';

export default function Gallery() {
  return (
    <main>
      <section className="page-hero page-hero-gallery"><div className="page-width"><span className="eyebrow">A closer look</span><h1>Gallery</h1><p>A glimpse of the spaces and moments that make your stay special.</p></div></section>
      <section className="section-pad page-width">
        <SectionHeading eyebrow="K and son’s Guest House" title="Explore the Gallery" description="Select an image to view it larger. Use Escape to close." />
        <GalleryGrid />
      </section>
    </main>
  );
}